import { ARENA_JOIN_FROM, ARENA_TZ } from "@/lib/arena-config";

const JOIN_FROM_LABEL = new Intl.DateTimeFormat("ru-RU", {
  timeZone: ARENA_TZ,
  day: "numeric",
  month: "long",
}).format(ARENA_JOIN_FROM);

/** Все тексты раздела «Свои на ARENA» — правятся здесь, без изменения кода. */
export const ARENA_COPY = {
  title: "Свои на ARENA",
  intro: [
    "Найди тех, с кем стоит познакомиться прямо на фестивале.",
    "Я подберу участников ARENA по интересам и тому, кого ты ищешь.",
    "Люди — это возможности. Открывай их: познакомься минимум с одним, а дальше сколько захочешь 🐾",
  ],
  counter: (n: number) => `Уже на ARENA: ${n}`,
  ctaSignIn: "Войти и найти своих",
  joinClosed: "Набор участников закрыт",
  joinClosedNote: "Спасибо всем, кто был с нами на ARENA!",
  joinSoon: `Присоединиться можно с ${JOIN_FROM_LABEL}`,
  joinSoonNote: "Сохрани ссылку — вернись сюда, когда откроется набор 🐾",

  consentTitle: "Ты на ARENA?",
  consentText:
    "Тебя увидят другие участники ARENA: имя, фото, чем занимаешься и кого ищешь. Видно только участникам раздела.",
  consentCta: "Да, я здесь",
  consentLater: "Не сейчас",

  daysTitle: "Когда ты будешь на ARENA?",
  days24: "24 октября",
  days25: "25 октября",
  daysBoth: "Оба дня",
  daysCta: "Дальше",
  daysPick: "Когда ты будешь на фестивале?",

  wizardIntro: "Пара коротких шагов, чтобы участники ARENA поняли, о чём с тобой поговорить 🐾",
  aboutTitle: "Расскажи о себе",
  aboutHint: "Пара фраз: чем занимаешься и о чём с тобой интересно поговорить",
  aboutPlaceholder: "Например: делаю бренды для кафе, люблю горы и ищу партнёров по бегу",
  purposeTitle: "Кого ищешь на ARENA?",
  purposeHint: "Выбери хотя бы один вариант",
  seekingTitle: "Кого и что ищешь на ARENA?",
  seekingHint:
    "Напиши своими словами: кого и что ты ищешь и зачем. Участники прочитают это на твоей карточке и сами решат, подходят ли они",
  seekingPlaceholder:
    "Например: я организатор благотворительного сообщества Simply People. Ищу тех, кто хочет помогать детям Африки получать образование и обустраивать быт",
  seekingExample:
    "Ещё примеры: веду программу Run Your Mind, ищу фасилитаторов · хочу найти клиентов для своей студии",
  photoTitle: "Добавь своё фото",
  photoHint:
    "Постарайся всё-таки загрузить фото: так вы быстрее найдёте друг друга на фестивале. Сделай селфи прямо сейчас, это пара секунд. Потом всегда сможешь заменить его в профиле",
  photoSelfie: "Сделать селфи",
  photoGallery: "Выбрать из галереи",
  photoLater: "Добавлю позже",
  photoSkipTitle: "Без фото тебя сложнее найти на фестивале",
  photoSkipText: "Люди охотнее зовут на кофе тех, чьё лицо видят. Это займёт пару секунд",
  photoSkipAnyway: "Всё равно позже",
  photoReminder: "Добавь фото, чтобы тебя узнали на фестивале",
  lookingLabel: "Ищет:",

  task: "Познакомься минимум с одним человеком, а дальше сколько захочешь",
  taskSteps: "☕ Пригласи на кофе → встреча у стенда TurkeyDrive → после встречи нажми «Мы встретились» (подтвердить нужно обоим)",
  opportunities: (n: number) => `Знакомств: ${n}`,
  firstSticker: "Первое знакомство даёт стикер 🐾",
  progressOf: (done: number, total: number) => `${done} из ${total}`,
  milestones: {
    1: "Первая дверь открыта",
    3: "Уже три. Ты в потоке",
    5: "Пять возможностей. Вот это арена!",
    10: "Десять! Ты душа ARENA",
  } as Record<number, string>,
  dayAll: "Все",
  hereToday: "Сегодня здесь",
  pickedForYou: "Подобрал для тебя",
  searchPlaceholder: "Поиск по имени или запросу",
  empty: "Пока здесь никого нет — скоро подтянутся 🐾",
  emptyFiltered: "Никого не нашлось. Попробуй другой фильтр",
  seekingReminderTitle: "Напиши, кого и что ищешь на ARENA",
  seekingSave: "Сохранить",
  seekingSaved: "Сохранено ✓",
  instagramLabel: "Instagram (по желанию)",
  instagramHint: "Чтобы тебя нашли после фестиваля. Увидят только после принятого приглашения на кофе",
  met: "Мы встретились",
  confirmCta: "Да, мы встретились",
  pendingForMe: (name: string) => `${name} отметил(а) встречу с тобой. Подтверди`,
  pendingBanner: (n: number) => `Тебя ждут подтверждения: ${n}`,
  pendingShow: "Показать",
  metDone: "Встреча состоялась ✓",
  confirmed: "Отмечено! Когда подтвердит второй человек, встреча засчитается",
  completedToast: "Встреча засчитана 🎉",
  reasonInterests: (list: string) => `Общее: ${list}`,
  reasonLooking: "Похожие цели",
  reasonHelp: (text: string) => `Может помочь: ${text}`,
  reasonIndustry: (text: string) => `Одна сфера: ${text}`,
  reasonDefault: "Тоже на ARENA",

  taskDoneTitle: "Задание выполнено ✓",
  taskDoneText: "Покажи этот экран на стойке TurkeyDrive и получи стикер",
  stickerCta: "Получить стикер",
  stickerDone: "Стикер получен ✓",
  continueTitle: "Продолжай искать своих 🐾",
  nextAllDone: "Ты прошёл все ступени. Но знакомиться можно дальше",
  nextNoOne: "Пока ты познакомился со всеми, кто здесь. Скоро подтянутся новые 🐾",
  countToast: (n: number) => `Знакомств: ${n} 🎉`,
  acquainted: "Знакомы ✓",
  stickerAlready: "Стикер уже выдан",

  meetingPoint: "у стенда TurkeyDrive",
  inviteMessage:
    "Привет! Я тоже на ARENA. Давай выпьем кофе на фестивале и познакомимся. Встретимся у стенда TurkeyDrive.",
  inviteSent: "Отправлено",
  inviteCta: "Пригласить на кофе",
  inviteSentCta: "Приглашение отправлено ✓",
  inviteIncoming: (name: string) => `${name} приглашает тебя на кофе`,
  inviteCalls: (name: string) => `${name} зовёт тебя на кофе`,
  inviteAccept: "Принять",
  inviteDecline: "Не сейчас",
  inviteAgreed: "Кофе договорились ✓",
  waiting: (name: string) => `Ждём ${name}`,
  backToArena: "← Назад в «Свои на ARENA»",
  inviteDeclined: "Не получилось договориться",
  inviteBanner: (n: number) => `Тебя приглашают на кофе: ${n}`,
  inviteAcceptedToast: "Договорились! Теперь видны контакты друг друга",
  inviteDeclinedToast: "Ответ отправлен",
  inviteNoContact: "Сначала добавь контакт для связи",

  partnerHost: "Евгении Изотовой",
  partnerTitle: (host: string) => `Сообщество ${host}`,
  partnerNote: "Вступи в сообщество, чтобы получать анонсы её встреч. Выйти можно в любой момент",
  partnerJoin: "Вступить в сообщество",
  partnerMember: "Ты в сообществе ✓",
  partnerJoinedToast: "Ты в сообществе ✓",
  partnerJoinError: "Не получилось вступить. Попробуй ещё раз",
  partnerView: "Посмотреть сообщество",
  partnerOpen: "Открыть сообщество",

  homeTile: "ARENA 24–25 октября: найди своих",
  homeTileNote: "Знакомься с участниками фестиваля прямо на месте",
  navLabel: "ARENA",

  errors: {
    join_closed: "Набор участников закрыт",
    not_participant: "Сначала присоединись к ARENA",
    self_meeting: "С собой встретиться не получится 🙂",
    already_given: "Стикер уже выдан",
    no_meeting: "Сначала встреться хотя бы с одним человеком",
    bad_days: "Выбери хотя бы один день",
    no_invite: "Сначала договорись о кофе: пригласи человека и дождись ответа",
    generic: "Не получилось — попробуй ещё раз",
  } as Record<string, string>,
} as const;

/** Понятный текст ошибки по коду из базы. */
export function arenaErrorText(e: unknown): string {
  const msg =
    e instanceof Error
      ? e.message
      : typeof e === "object" && e && "message" in e
        ? String((e as { message: unknown }).message)
        : "";
  for (const [code, text] of Object.entries(ARENA_COPY.errors)) {
    if (msg.includes(code)) return text;
  }
  return ARENA_COPY.errors.generic;
}
